import { createAccessControl } from 'better-auth/plugins/access';
import { defaultStatements } from 'better-auth/plugins/organization/access';

export const statement = {
  ...defaultStatements,
  projects: ['create', 'read', 'update', 'delete'],
  agents: ['create', 'read', 'update', 'delete'],
  bids: ['create', 'read', 'update', 'delete'],
  comments: ['create', 'read', 'update', 'delete'],
  files: ['create', 'read', 'update', 'delete'],
  items: ['create', 'read', 'update', 'delete'],
  imports: ['create', 'read', 'update', 'delete'],
  lettings: ['create', 'read', 'update', 'delete'],
  owners: ['create', 'read', 'update', 'delete'],
  proposals: ['create', 'read', 'update', 'delete'],
  threads: ['create', 'read', 'update', 'delete'],
  vendors: ['create', 'read', 'update', 'delete'],
  settings: ['read', 'update'],
  exportJobs: ['create', 'read', 'delete'],
  postProcessings: ['create', 'read', 'update', 'delete'],
  forecasts: ['create', 'read', 'update', 'delete'],
} as const;

export const ac = createAccessControl(statement);

export const owner = ac.newRole({
  organization: ['update'],
  member: ['create', 'update', 'delete'],
  projects: [...statement.projects],
  agents: [...statement.agents],
  settings: [...statement.settings],
  exportJobs: [...statement.exportJobs],
  bids: [...statement.bids],
  comments: [...statement.comments],
  files: [...statement.files],
  items: [...statement.items],
  imports: [...statement.imports],
  lettings: [...statement.lettings],
  owners: [...statement.owners],
  proposals: [...statement.proposals],
  threads: [...statement.threads],
  vendors: [...statement.vendors],
  postProcessings: [...statement.postProcessings],
  forecasts: [...statement.forecasts],
});

export const admin = ac.newRole({
  member: ['create', 'update', 'delete'],
  projects: [...statement.projects],
  agents: [...statement.agents],
  settings: [...statement.settings],
  exportJobs: [...statement.exportJobs],
  bids: [...statement.bids],
  comments: [...statement.comments],
  files: [...statement.files],
  items: [...statement.items],
  imports: [...statement.imports],
  lettings: [...statement.lettings],
  owners: [...statement.owners],
  proposals: [...statement.proposals],
  threads: [...statement.threads],
  vendors: [...statement.vendors],
  postProcessings: [...statement.postProcessings],
  forecasts: [...statement.forecasts],
});

export const editor = ac.newRole({
  projects: [...statement.projects],
  agents: [...statement.agents],
  bids: [...statement.bids],
  comments: [...statement.comments],
  files: [...statement.files],
  items: [...statement.items],
  imports: [...statement.imports],
  lettings: [...statement.lettings],
  owners: [...statement.owners],
  proposals: [...statement.proposals],
  threads: [...statement.threads],
  vendors: [...statement.vendors],
  settings: [...statement.settings],
  exportJobs: [...statement.exportJobs],
  postProcessings: [...statement.postProcessings],
  forecasts: [...statement.forecasts],
});

export const viewer = ac.newRole({
  projects: ['read'],
  agents: ['read'],
  bids: ['read'],
  comments: ['read'],
  files: ['read'],
  items: ['read'],
  imports: ['read'],
  lettings: ['read'],
  owners: ['read'],
  proposals: ['read'],
  threads: ['read'],
  vendors: ['read'],
  exportJobs: ['read'],
  postProcessings: ['read'],
  forecasts: ['read'],
});

export const roles = {
  owner,
  admin,
  editor,
  viewer,
};
